<div class="mt-4 d-flex align-items-center" style="justify-content: space-evenly" >
  <div class="button-container" *ngIf="!isCurrentMenu">
    <ng-container *ngFor="let tag of tagItems">
        <button *ngIf="tag.display" (click)="onMealTagChange(tag.id)"
        [style.background-color]="selectedTagId === tag.id ? '#dfdfef' : 'transparent'"
        class="btn mt-2 mx-2 categoriesButton">
        {{ tag.name }}
      </button>
    </ng-container>
  </div>
  <div class="button-container" *ngIf="isCurrentMenu">
    <ng-container *ngFor="let mealType of mealTypes">
        <button (click)="onMealTypeChange(mealType)"
        [style.background-color]="selectedMealType === mealType ? '#dfdfef' : 'transparent'"
        class="btn mt-2 mx-2 categoriesButton">
        {{ mealType }}
      </button>
    </ng-container>
  </div>
  <div id="category-search-bar" class="d-flex align-items-center" style="gap: 15px;">
    <div class="category-box" *ngIf="!hideCategories">
      <p-multiSelect [options]="categories" optionLabel="name" [maxSelectedLabels]="2" selectedItemsLabel="{0} items selected" [showClear]="false" [filter]="false" [(ngModel)]="selectedCategories" placeholder="Categories" (ngModelChange)="onSelectedCategory($event)" />
    </div>
    <div class="search-box">
      <span class="p-input-icon-left w-100">
        <i class="pi pi-search" style="font-size: 1rem;font-weight: 400;color: #5D5D66;" *ngIf="searchIcon"></i>
        <input type="text" class="p-2 input-promo mainLoginInput fm-rubik" placeholder="      Search meal"
          style="font-size: 1rem;font-weight: 400;color: #5D5D66;" (input)="inputTextChange($event)"
          [(ngModel)]="search" />
      </span>
    </div>
  </div>
</div>